import React from 'react';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { I18nProvider } from './contexts/I18nProvider';
import { ErrorBoundary } from './components/common/ErrorBoundary';
import { EnvironmentBanner } from './components/common/EnvironmentBanner';
import { Login } from './components/auth/Login';
import { WarehouseMain } from './components/warehouse/WarehouseMain';

const AppContent: React.FC = () => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Login />;
  }

  return <WarehouseMain />;
};

const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <EnvironmentBanner />
      <AuthProvider>
        <I18nProvider>
          <AppContent />
        </I18nProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
};

export default App;
